module.exports = __webpack_public_path__ + "img/5.818eecb4.svg";